"use strict";
exports.__esModule = true;
var currency_1 = require("./currency");
var account_1 = require("./account");
exports["default"] = {
    currencyBridge: currency_1.currencyBridge,
    accountBridge: account_1.accountBridge
};
//# sourceMappingURL=js.js.map